import React, {useEffect, useState} from 'react';
import {t} from "i18next";
import {Modal} from "@/components/Modal";
import {deleteEducation, updateEducation} from "@/service/accountApi";
import Cookies from "universal-cookie";

export const EditEducationForm = (props) => {
	const {
		showEditEducationForm,
		setShowEditEducationForm,
		educationData,
		setEducationData,
		accountDetails,
		setAccountDetails
	} = props;

	const cookies = new Cookies();
	const locale = cookies.get("locale");

	const [error, setError] = useState({});

	const [isUpdateEducationButtonDisabled, setIsUpdateEducationButtonDisabled] = useState(false);
	const [isDeleteEducationButtonDisabled, setIsDeleteEducationButtonDisabled] = useState(false);

	const [educationDetails, setEducationDetails] = useState({
		_id: '',

		schoolOrCollegeName: '',
		degree: '',
		courseOfStudy: '',

		result: '',
		startDate: '',
		endDate: '',

		isCurrentEducation: false,

		city: '',
		state: '',
		country: '',
	});

	const [showDeleteEducationDetailsConfirmationModal, setShowDeleteEducationDetailsConfirmationModal] = useState(false);

	const [needAssistance, setNeedAssistance] = useState(false);
	const [needAssistanceDescription, setNeedAssistanceDescription] = useState('');

	const handleFormData = (e) => {
		console.log(e.target.name + ': ' + e.target.value);

		setEducationDetails({
			...educationDetails,
			[e.target.name]: e.target.value
		});

		setError({
			...error,
			[e.target.name]: ""
		});
	}

	const validate = () => {
		let err = {};

		if (educationDetails.schoolOrCollegeName === '') {
			err['schoolOrCollegeName'] = t("EDUCATION_FORM.SCHOOL_COLLEGE_NAME.REQUIRED_ERROR");
		}

		if (educationDetails.degree === '') {
			err['degree'] = t("EDUCATION_FORM.DEGREE.REQUIRED_ERROR");
		}

		if (educationDetails.courseOfStudy === '') {
			err['courseOfStudy'] = t("EDUCATION_FORM.COURSE_OF_STUDY.REQUIRED_ERROR");
		}

		if (educationDetails.result === '') {
			err['result'] = t("EDUCATION_FORM.RESULT.REQUIRED_ERROR");
		}

		if (educationDetails.startDate === '') {
			err['startDate'] = t("EDUCATION_FORM.START_DATE.REQUIRED_ERROR");
		}

		if (!educationDetails.isCurrentEducation) {
			if (educationDetails.endDate === '') {
				err['endDate'] = t("EDUCATION_FORM.END_DATE.REQUIRED_ERROR");
			}
		}

		if (educationDetails.city === '') {
			err['city'] = t("EDUCATION_FORM.CITY.REQUIRED_ERROR");
		}

		if (educationDetails.state === '') {
			err['state'] = t("EDUCATION_FORM.STATE.REQUIRED_ERROR");
		}

		if (educationDetails.country === '') {
			err['country'] = t("EDUCATION_FORM.COUNTRY.REQUIRED_ERROR");
		}

		return err;
	}

	const handleDelete = async () => {
		console.log("Inside Handle Delete!");
		setIsDeleteEducationButtonDisabled(true);

		console.log("Education Details to Delete: ", educationDetails);

		const educationData = {
			userAccountId: accountDetails._id,
			educationId: educationDetails._id,
		};

		const deleteEducationDataResponse = await deleteEducation(educationData);

		console.log('(AddEducationForm) Delete Education Data Response: ', deleteEducationDataResponse);

		if (deleteEducationDataResponse.success) {
			setAccountDetails(deleteEducationDataResponse.data);
			setShowDeleteEducationDetailsConfirmationModal(false);
			setShowEditEducationForm(false);
			setIsUpdateEducationButtonDisabled(false);
			setIsDeleteEducationButtonDisabled(false);
			setTimeout(() => {
				setEducationDetails({
					_id: '',

					schoolOrCollegeName: '',
					degree: '',
					courseOfStudy: '',

					result: '',
					startDate: '',
					endDate: '',

					isCurrentEducation: false,

					city: '',
					state: '',
					country: '',
				});
				setEducationData(null);
			}, 200);
		}
	}

	const handleSubmit = async () => {
		console.log("Inside Handle Submit!");
		setIsUpdateEducationButtonDisabled(true);
		const err = validate();

		if (Object.keys(err).length > 0) {
			setError(err);
			setIsUpdateEducationButtonDisabled(false);
			return;
		}

		console.log("Education Details: ", educationDetails);

		const educationData = {
			userAccountId: accountDetails._id,
			educationDetails: educationDetails,
		};
		const updateEducationDataResponse = await updateEducation(educationData);

		console.log('(AddEducationForm) Update Education Data Response: ', updateEducationDataResponse);

		if (updateEducationDataResponse.success) {
			setAccountDetails(updateEducationDataResponse.data);
			setShowEditEducationForm(false);
			setIsUpdateEducationButtonDisabled(false);
			setTimeout(() => {
				setEducationDetails({
					_id: '',

					schoolOrCollegeName: '',
					degree: '',
					courseOfStudy: '',

					result: '',
					startDate: '',
					endDate: '',

					isCurrentEducation: false,

					city: '',
					state: '',
					country: '',
				});
				setEducationData(null);
			}, 200);
		}
	}

	useEffect(() => {
		if (educationData) {
			console.log("Education Data: ", educationData);
			setEducationDetails({
				_id: educationData._id,

				schoolOrCollegeName: educationData.schoolOrCollegeName,
				degree: educationData.degree,
				courseOfStudy: educationData.courseOfStudy,

				result: educationData.result,
				startDate: new Date(educationData.startDate).toISOString().slice(0, 7),
				endDate: educationData.endDate ? new Date(educationData.endDate).toISOString().slice(0, 7) : "",

				isCurrentEducation: educationData.isCurrentEducation,

				city: educationData.city,
				state: educationData.state,
				country: educationData.country,
			});
		}
	}, [educationData]);

	return (
		<>
			<Modal isOpen={showEditEducationForm}>
				<div className="form-modal-container">
					{/* Header */}
					<div className={"form-modal-header-container"}>
						{/* Header Title | Close Button */}
						<div className={"flex flex-row items-center justify-between"}>
							{/* Form Title */}
							<h2>
								{t("EDUCATION_FORM.EDIT_TITLE")}
							</h2>

							<button
								onClick={() => {
									setTimeout(() => {
										setEducationDetails({
											_id: '',

											schoolOrCollegeName: '',
											degree: '',
											courseOfStudy: '',

											result: '',
											startDate: '',
											endDate: '',

											isCurrentEducation: false,

											city: '',
											state: '',
											country: '',
										});
										setEducationData(null);
										setError({});
									}, 200);
									setShowEditEducationForm(false);
								}}
							>
								<img
									className={"w-[75%] h-[75%]"}
									src={"/assets/close-icon.png"}
									alt={"Close"}
									title={"Close"}
								/>
							</button>
						</div>

						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
					</div>

					{/* Form Fields */}
					<div className={"form-modal-body-container"}>
						{/* School / College Name */}
						<fieldset>
							<div className="custom-input-container">
								<label htmlFor="schoolOrCollegeName">
									{t("EDUCATION_FORM.SCHOOL_COLLEGE_NAME.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="schoolOrCollegeName"
										className="custom-input"
										name='schoolOrCollegeName'
										value={educationDetails.schoolOrCollegeName}
										onChange={handleFormData}
									/>
									{
										error['schoolOrCollegeName'] &&
										<p className="custom-input-error-message" id="error">
											{error['schoolOrCollegeName']}
										</p>
									}
								</div>
							</div>
						</fieldset>

						{/* Degree */}
						<fieldset>
							<div className="custom-input-container">
								<label htmlFor="degree">
									{t("EDUCATION_FORM.DEGREE.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="degree"
										className="custom-input"
										name='degree'
										value={educationDetails.degree}
										onChange={handleFormData}
									/>
									{
										error['degree'] &&
										<p className="custom-input-error-message" id="error">
											{error['degree']}
										</p>
									}
								</div>
							</div>
						</fieldset>

						{/* Course Of Study */}
						<fieldset>
							<div className="custom-input-container">
								<label htmlFor="courseOfStudy">
									{t("EDUCATION_FORM.COURSE_OF_STUDY.LABEL")}
								</label>

								<div className="flex-1 flex flex-col">
									<input
										id="courseOfStudy"
										className="custom-input"
										name='courseOfStudy'
										value={educationDetails.courseOfStudy}
										onChange={handleFormData}
									/>
									{
										error['courseOfStudy'] &&
										<p className="custom-input-error-message" id="error">
											{error['courseOfStudy']}
										</p>
									}
								</div>
							</div>
						</fieldset>

						{/* Result | Start Date | End Date */}
						<fieldset>
							<div className="custom-input-multiple-fields-container">
								{/* Result */}
								<div
									className="custom-input-container portrait:!w-full
                                        portrait:md:!w-1/3 landscape:!w-1/3"
								>
									<label htmlFor="result">
										{t("EDUCATION_FORM.RESULT.LABEL")}
									</label>

									<div className="flex-1 flex flex-col">
										<input
											id="result"
											className="custom-input"
											name='result'
											value={educationDetails.result}
											onChange={handleFormData}
										/>
										{
											error['result'] &&
											<p className="custom-input-error-message" id="error">
												{error['result']}
											</p>
										}
									</div>
								</div>

								{/* Start Date */}
								<div
									className="custom-input-container portrait:!w-full
                                        portrait:md:!w-1/3 landscape:!w-1/3"
								>
									<label htmlFor="startDate">
										{t("EDUCATION_FORM.START_DATE.LABEL")}
									</label>
									<div className="relative w-full">
										<input
											type={"month"}
											name='startDate'
											required
											value={educationDetails.startDate}
											onChange={handleFormData}
											className={`custom-input`}
										/>
										{
											error['startDate'] &&
											<p className="custom-input-error-message" id="error">
												{error['startDate']}
											</p>
										}
									</div>
								</div>

								{/* End Date */}
								<div
									className="custom-input-container portrait:!w-full
                                        portrait:md:!w-1/3 landscape:!w-1/3"
								>
									<label htmlFor="endDate">
										{t("EDUCATION_FORM.END_DATE.LABEL")}
									</label>
									<div className="relative w-full">
										<input
											disabled={educationDetails.isCurrentEducation}
											type={"month"}
											name='endDate'
											value={educationDetails.endDate}
											onChange={handleFormData}
											className="custom-input"
										/>
										{
											error['endDate'] &&
											<p className="custom-input-error-message" id="error">
												{error['endDate']}
											</p>
										}
									</div>
								</div>
							</div>
						</fieldset>

						{/* Current Education CheckBox */}
						<fieldset>
							<label className="custom-input-label-checkbox">
								<input
									type="checkbox"
									name='isCurrentEducation'
									checked={educationDetails.isCurrentEducation}
									onChange={(e) => {
										setEducationDetails({
											...educationDetails,
											isCurrentEducation: e.target.checked,
											endDate: ""
										});
									}}
								/>
								<p>
									{t("EDUCATION_FORM.PRESENT")}
								</p>
							</label>
						</fieldset>

						{/* City | State | Country */}
						<fieldset>
							<div className="custom-input-multiple-fields-container flex-wrap">
								{/* City */}
								<div className="custom-input-container">
									<label htmlFor="city">
										{t("EDUCATION_FORM.CITY.LABEL")}
									</label>

									<div className="flex-1 flex flex-col">
										<input
											id="city"
											className="custom-input"
											name='city'
											value={educationDetails.city}
											onChange={handleFormData}
										/>
										{
											error['city'] &&
											<p className="custom-input-error-message" id="error">
												{error['city']}
											</p>
										}
									</div>
								</div>

								{/* State */}
								<div className="custom-input-container">
									<label htmlFor="state">
										{t("EDUCATION_FORM.STATE.LABEL")}
									</label>

									<div className="flex-1 flex flex-col">
										<input
											id="state"
											className="custom-input"
											name='state'
											value={educationDetails.state}
											onChange={handleFormData}
										/>
										{
											error['state'] &&
											<p className="custom-input-error-message" id="error">
												{error['state']}
											</p>
										}
									</div>
								</div>

								{/* Country */}
								<div className="custom-input-container">
									<label htmlFor="country">
										{t("EDUCATION_FORM.COUNTRY.LABEL")}
									</label>

									<div className="flex-1 flex flex-col">
										<input
											id="country"
											className="custom-input"
											name='country'
											value={educationDetails.country}
											onChange={handleFormData}
										/>
										{
											error['country'] &&
											<p className="custom-input-error-message" id="error">
												{error['country']}
											</p>
										}
									</div>
								</div>
							</div>
						</fieldset>
					</div>

					{/* Footer */}
					<div className={"form-modal-footer-container"}>
						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

						{/* Delete | Submit */}
						<div className="flex flex-row items-center justify-between">
							{/* Delete Button */}
							<button
								disabled={isDeleteEducationButtonDisabled || isUpdateEducationButtonDisabled}
								onClick={() => setShowDeleteEducationDetailsConfirmationModal(true)}
								className="form-modal-footer-container-delete-button"
							>
								<img
									src="/assets/delete-icon-filled-light.png"
									alt="Delete"
								/>
								{t("EDUCATION_FORM.DELETE")}
							</button>

							{/* Submit Button */}
							<button
								disabled={isUpdateEducationButtonDisabled || isDeleteEducationButtonDisabled}
								onClick={handleSubmit}
								className="form-modal-footer-container-submit-button"
							>
								<p>
									{t("EDUCATION_FORM.EDIT_SUBMIT")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="black"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="black"
										strokeLinecap="square"
									/>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete Education */}
			<Modal isOpen={showDeleteEducationDetailsConfirmationModal}>
				<div className="delete-modal-container">
					{/* Header */}
					<div className={"delete-modal-header-container"}>
						{/* Header Title | Close Button */}
						<div className={"flex flex-row items-center justify-between"}>
							{/* Form Title */}
							<h2>
								{t("EDUCATION_FORM.DELETE_MODAL.TITLE")}
							</h2>

							<button
								onClick={() => setShowDeleteEducationDetailsConfirmationModal(false)}
							>
								<img
									className={"w-[75%] h-[75%]"}
									src={"/assets/close-icon.png"}
									alt={"Close"}
									title={"Close"}
								/>
							</button>
						</div>

						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
					</div>

					{/* Content */}
					<div className={"delete-modal-body-container"}>
						<p>
							{
								locale === "en"
									?
									<>
										{t("EDUCATION_FORM.DELETE_MODAL.DESCRIPTION", {
											pronoun: window.location.pathname.includes("personal-profile") ? "your" : "their"
										})}
										<span className={"!font-custom-semi-bold underline"}>
                                            {educationDetails.schoolOrCollegeName}
                                        </span>
										?
									</>
									:
									<>
										{t("EDUCATION_FORM.DELETE_MODAL.DESCRIPTION_P1", {
											pronoun: window.location.pathname.includes("personal-profile") ? "आपले" : "त्यांचे"
										})}
										<span className={"!font-custom-semi-bold underline"}>
                                            {educationDetails.schoolOrCollegeName}
                                        </span>
										{t("EDUCATION_FORM.DELETE_MODAL.DESCRIPTION_P2")}
									</>
							}
						</p>
					</div>

					{/* Footer */}
					<div className={"delete-modal-footer-container"}>
						{/* Divider */}
						<div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>

						{/* Delete | Update */}
						<div className="flex flex-row items-center justify-between">
							{/* Cancel Button */}
							<button
								disabled={isDeleteEducationButtonDisabled}
								onClick={() => setShowDeleteEducationDetailsConfirmationModal(false)}
								className="delete-modal-footer-container-cancel-button"
							>
								<p>
									{t("EDUCATION_FORM.DELETE_MODAL.CANCEL")}
								</p>
								<svg
									viewBox="0 0 6 6"
									fill="none"
									id={"arrow-icon"}
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M3 1L5 3L3 5"
										id={"arrow-icon-tip"}
										stroke="black"
										strokeLinecap="square"
									/>
									<path
										d="M1 3L4 3"
										id={"arrow-icon-line"}
										stroke="black"
										strokeLinecap="square"
									/>
								</svg>
							</button>

							{/* Delete Button */}
							<button
								disabled={isDeleteEducationButtonDisabled}
								onClick={handleDelete}
								className="delete-modal-footer-container-delete-button"
							>
								<img
									src="/assets/delete-icon-filled-light.png"
									alt="Delete"
								/>
								<p>
									{t("EDUCATION_FORM.DELETE_MODAL.DELETE")}
								</p>
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</>
	);
}
